import React from 'react';
import SectionCard from './SectionCard';

const ICONS = {
  trophy: '🏆',
  flame: '🔥',
  star: '⭐',
  book: '📚',
  target: '🎯',
  rocket: '🚀',
  moon: '🌙',
  sun: '☀️',
  fire: '🔥',
  graduation: '🎓',
};

// Badges kept from the previous screen, restated as a quiet row of chips so
// they read as a record rather than a scoreboard.
export default function BadgesCard({ data }) {
  const badges = Array.isArray(data?.badges) ? data.badges : [];
  if (badges.length === 0) return null;

  const earned = data?.badgesEarnedCount ?? badges.filter((b) => b.earned).length;
  const totalCount = data?.badgesTotalCount ?? badges.length;
  const nextUp = badges.find((b) => !b.earned && b.progressLabel && b.description);

  return (
    <SectionCard
      title="Badges"
      meta={`${earned} of ${totalCount} earned`}
      lede={
        nextUp
          ? `${nextUp.name} is the next one within reach — ${nextUp.description.toLowerCase()}.`
          : 'Everything here is earned by finishing work, not by showing up.'
      }
      style={{ marginBottom: 18 }}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {badges.map((badge) => (
          <span
            key={badge.id}
            title={badge.description}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 11px',
              borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--border-subtle)',
              background: badge.earned ? 'var(--accent-light)' : 'transparent',
              color: badge.earned ? 'var(--text-primary)' : 'var(--text-tertiary)',
              fontSize: 12.5,
              fontWeight: badge.earned ? 500 : 400,
            }}
          >
            <span aria-hidden="true" style={{ filter: badge.earned ? 'none' : 'grayscale(1)', opacity: badge.earned ? 1 : 0.5 }}>
              {ICONS[badge.icon] || '🏅'}
            </span>
            {badge.name}
          </span>
        ))}
      </div>
    </SectionCard>
  );
}
